import { AdminAccessNotice } from "@/components/admin/access-notice";
import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/app-layout";
import { useIsAdmin } from "@/hooks/use-is-admin";
import { UsageInsightsPanel } from "@/components/admin/usage-insights-panel";
import { Loader2, ShieldOff } from "lucide-react";

export const Route = createFileRoute("/admin/insights")({
  component: AdminInsightsPage,
  head: () => ({
    meta: [
      { title: "Usage Insights — AskBell Admin" },
      { name: "description", content: "Analyze AskBell chats to find recurring tasks, pain points, and opportunities." },
      { property: "og:title", content: "Usage Insights — AskBell Admin" },
      { property: "og:description", content: "Recurring tasks, pain points, and opportunities across AskBell chats." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
});

function AdminInsightsPage() {
  const { isAdmin, loading, error: accessError, retry: retryAccess } = useIsAdmin();

  return (
    <AppLayout>
      <div className="flex-1 min-h-0 overflow-y-auto">
        <div className="mx-auto w-full max-w-5xl p-6">
        <h1 className="text-ui-2xl font-bold">Usage insights</h1>
        <p className="mt-1 text-ui-base text-muted-foreground">
          What the team actually asks AskBell for, where it keeps letting them down, and what to build next.
        </p>

        <div className="mt-6">
          {loading ? (
            <div className="flex items-center gap-2 text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Checking access…</div>
          ) : !isAdmin ? (
              <AdminAccessNotice error={accessError} retry={retryAccess} />
            ) : (
            <UsageInsightsPanel />
          )}
          </div>
        </div>
      </div>
    </AppLayout>
  );
}
